export default "__VITE_ASSET__CRBsBzF8__"